<section>
  <h1>Create <span class="emphasis">Customer Care</span> Ticket</h1>
  @if (careFormGroup) {
    <form
      [formGroup]="careFormGroup"
      [ngClass]="{ 'form-submit-attempt': formSubmitAttempted }"
      autocomplete="off"
    >
      <h2>General Information</h2>

      <div class="question">Subject</div>
      <mat-form-field class="custom-textarea">
        <mat-label>Tell us about the issue...</mat-label>
        <textarea matInput formControlName="subject" rows="1"></textarea>
      </mat-form-field>
      <div class="question">
        Please describe the issue(s) you're experiencing.
      </div>
      <mat-form-field class="custom-textarea">
        <mat-label>Tell us about the issue...</mat-label>
        <textarea matInput formControlName="description" rows="5"></textarea>
      </mat-form-field>
      <!-- Remove customer ticket number MN1-651
      <div class="question">Customer Ticket Number</div>
      <mat-form-field>
      <input matInput type="text" formControlName="customerTicketNumber" />
      </mat-form-field> -->
      @if (inlineErrors.description) {
        <div class="form-error">
          <div class="custom-icon inline_error"></div>
          <div class="error-message">{{ inlineErrors.description }}</div>
        </div>
      }

      <app-primary-reporter
        [formRef]="careFormGroup"
        [reporters]="primaryReporters"
        (usersLoaded)="usersLoaded()"
      >
      </app-primary-reporter>

      <app-service-location
        [formRef]="careFormGroup"
        [services]="services"
        [selectedServiceId]="selectedServiceId"
        [inlineErrors]="inlineErrors"
        [validateForNoc]="false"
        (servicesLoaded)="servicesLoaded()"
      >
      </app-service-location>

      @if (submissionError) {
        <div
          [ngClass]="{
            'form-error': !errorMessage,
            'server-error': errorMessage,
          }"
        >
          <div class="custom-icon inline_error"></div>
          <div class="error-message">
            {{
              errorMessage ??
                'Error: Unable to submit the ticket. Please try again!'
            }}
          </div>
        </div>
      }

      @if (isSubmitting) {
        <div class="loading-indicator">
          <mat-spinner [diameter]="25"></mat-spinner>
        </div>
      }

      <div class="flex justify-end mt-6">
        <button
          class="primary-button m-0"
          (click)="submitTicket()"
          [disabled]="loadingServices || loadingUsers || isSubmitting"
        >
          <span>Submit ticket</span>
        </button>
      </div>
    </form>
  }
</section>
